// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── Settings layout ─────────────────────────────────────────────────────── */
.settings-container {
  display: flex;
  height: calc(100vh - 50px);
  margin-top: 50px;
  overflow: hidden;
  background: #f1f5f9;
}

.settings-sidebar {
  width: 280px;
  min-width: 280px;
  height: 100%;
  flex-shrink: 0;
  background: #ffffff;
  border-right: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  padding: 0;
  overflow: hidden;
  box-shadow: 2px 0 12px rgba(15, 23, 42, 0.04);
}

.settings-sidebar-header {
  padding: 24px 20px 18px;
  border-bottom: 1px solid #f1f5f9;
  flex-shrink: 0;
}

.settings-sidebar-header h3 {
  margin: 0 0 6px;
  font-size: 1.25rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.02em;
}

.settings-sidebar-header p {
  margin: 0;
  font-size: 0.8125rem;
  color: #64748b;
  line-height: 1.4;
}

.settings-nav {
  padding: 12px 10px 20px;
  overflow: hidden;
  flex: 1 1;
}

.settings-content {
  flex: 1 1;
  min-width: 0;
  height: 100%;
  padding: 32px 24px 48px;
  overflow-y: auto;
  overflow-x: hidden;
  background: #f1f5f9;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

/* ─── Sidebar navigation ──────────────────────────────────────────────────── */
.sidebar-item {
  padding: 11px 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 4px;
  border-radius: 8px;
  transition:
    background-color 0.2s ease,
    color 0.2s ease;
  color: #475569;
  font-size: 0.875rem;
  font-weight: 500;
  border: 1px solid transparent;
}

.sidebar-item:hover {
  background-color: #f8fafc;
  color: #0f172a;
}

.sidebar-item.active {
  background: linear-gradient(135deg, #e0f2fe 0%, #f0f9ff 100%);
  color: #0369a1;
  border-color: #bae6fd;
  font-weight: 600;
}

.sidebar-item.active svg {
  color: #0284c7;
}

.sidebar-item svg {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  color: #94a3b8;
  transition: color 0.2s ease;
}

.sidebar-item:hover svg {
  color: #64748b;
}

.sidebar-item-label {
  line-height: 1.3;
}

/* ─── Page shell (centered on content area) ─────────────────────────────────── */
.settings-panel,
.dispatcher-settings,
.order-creation-settings,
.notification-settings {
  width: 100%;
  max-width: 95%;
  margin: 0 auto;
}

.settings-page-header {
  margin-bottom: 28px;
  /* text-align: center; */
}

.settingsH2,
.settings-page-header h2 {
  font-size: 1.75rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 8px;
  letter-spacing: -0.03em;
  font-family: inherit;
}

.settings-page-subtitle {
  margin: 0 auto;
  font-size: 0.9375rem;
  color: #64748b;
  line-height: 1.5;
  max-width: auto;
}

/* ─── Cards & sections ────────────────────────────────────────────────────── */
.settings-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 24px 28px;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
}

.settings-card:last-child {
  margin-bottom: 0;
}

.settings-card-title {
  font-size: 1rem;
  font-weight: 600;
  color: #0f172a;
  margin: 0 0 4px;
  text-align: center;
}

.settings-card-desc {
  font-size: 0.8125rem;
  color: #64748b;
  margin: 0 0 20px;
  line-height: 1.45;
  text-align: center;
}

.detailsh2 {
  font-size: 1rem;
  font-weight: 600;
  color: #0f172a;
  margin: 0 0 16px;
  font-family: inherit;
}

.setting-option {
  margin: 0;
}

.setting {
  margin: 0;
}

.settings-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
}

.settings-info-item {
  padding: 14px 16px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.settings-info-label {
  display: block;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
  margin-bottom: 6px;
}

.settings-info-value {
  font-size: 0.9375rem;
  font-weight: 500;
  color: #0f172a;
  word-break: break-word;
}

/* ─── Form controls ───────────────────────────────────────────────────────── */
.dropdown-container {
  display: grid;
  /* grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)); */
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
  margin: 0 auto;
  max-width: auto;
}

.settingg {
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.settingg label,
.dropdown-container label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #334155;
  line-height: 1.4;
}

.dropdown-container select,
.settingg select,
.settingg input[type="time"],
.settingg input[type="number"],
.settings-input {
  padding: 10px 12px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background-color: #ffffff;
  font-size: 0.875rem;
  color: #0f172a;
  outline: none;
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;
  width: 100%;
  margin: 0;
  font-family: inherit;
  box-sizing: border-box;
}

.dropdown-container select:focus,
.settingg select:focus,
.settingg input:focus,
.settings-input:focus {
  border-color: #38bdf8;
  box-shadow: 0 0 0 3px rgba(56, 189, 248, 0.15);
}

/* ─── Centered form wrapper inside cards ────────────────────────────────────── */
.settings-form-wrap {
  width: 100%;
  max-width: 420px;
  margin: 0 auto !important;
}

.settings-save-row {
  margin-top: 28px !important;
  padding-top: 4px;
  width: 100%;
  text-align: center;
}

.settings-card .MuiTypography-body2 {
  text-align: center;
  max-width: 420px;
  margin: 12px auto 0;
  font-size: 0.8125rem;
  color: #64748b;
}

/* ─── Compact toggle switches (settings page only) ──────────────────────────── */
.settings-toggle-switch {
  position: relative;
  display: inline-block;
  width: 26px;
  height: 14px;
  flex-shrink: 0;
  vertical-align: middle;
}

.settings-toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.settings-toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #cbd5e1;
  transition: 0.2s ease;
  border-radius: 14px;
}

.settings-toggle-slider:before {
  position: absolute;
  content: "";
  height: 8px;
  width: 8px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.2s ease;
  border-radius: 50%;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
}

.settings-toggle-switch input:checked + .settings-toggle-slider {
  background-color: #38bdf8;
}

.settings-toggle-switch input:focus + .settings-toggle-slider {
  box-shadow: 0 0 0 2px rgba(56, 189, 248, 0.25);
}

.settings-toggle-switch input:checked + .settings-toggle-slider:before {
  transform: translateX(12px);
}

/* ─── Toggle rows ─────────────────────────────────────────────────────────── */
.toggle-row > *:last-child {
  flex: 0 0 auto;
}

.toggle-roww > *:last-child {
  flex: 0 0 auto;
}

.whatsapp-toggle-row > *:last-child {
  flex: 0 0 auto;
}

.toggle-row .settings-toggle-switch,
.toggle-row .MuiSwitch-root {
  flex-shrink: 0;
}

.toggle-row,
.toggle-roww,
.whatsapp-toggle-row {
  width: 100%;
  max-width: 420px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid #f1f5f9;
}

.toggle-row:last-child,
.toggle-roww:last-child,
.whatsapp-toggle-row:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.toggle-row:first-child,
.toggle-roww:first-child,
.whatsapp-toggle-row:first-child {
  padding-top: 0;
}

.toggle-row label,
.toggle-roww label,
.whatsapp-toggle-row label {
  flex: 1 1;
  min-width: 0;
  font-size: 0.875rem;
  font-weight: 500;
  color: #334155;
  margin: 0;
  line-height: 1.4;
}

.toggle-group {
  padding-top: 4px;
  max-width: 420px;
  margin: 0 auto;
}

.order-creation-settings .Pickupp {
  padding: 0;
  font-size: 0.9375rem;
  color: #0f172a;
  margin: 0;
  font-weight: 600;
}

/* ─── Dispatcher settings ─────────────────────────────────────────────────── */
.dispatcher-section {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 24px 28px;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
}

.dispatcher-section h3 {
  padding: 0;
  font-size: 1.0625rem;
  color: #0f172a;
  margin: 0 0 16px;
  font-weight: 600;
  text-align: center;
}

/* ─── WhatsApp settings ───────────────────────────────────────────────────── */
.whatsapp-section-title {
  font-size: 1rem;
  font-weight: 600;
  color: #0f172a;
  margin: 0 0 12px;
  text-align: center;
}

.whatsapp-messages {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 8px 20px;
  margin: 0 auto 24px;
  max-width: 98%;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
}

.whatsapp-settings-note {
  font-size: 0.8125rem;
  color: #64748b;
  margin: 8px auto 0;
  max-width: 420px;
  padding: 12px 16px;
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 8px;
  text-align: center;
}

.requiredFields {
  color: #ef4444;
  margin-left: 4px;
}

/* ─── Chart / billing section ───────────────────────────────────────────────── */
.settings-chart-wrap {
  position: relative;
  padding-top: 8px;
}

.settings-chart-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
}

.settings-year-select {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 10;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 0.875rem;
  color: #334155;
  background: #ffffff;
  outline: none;
  cursor: pointer;
}

.settings-year-select:focus {
  border-color: #38bdf8;
  box-shadow: 0 0 0 3px rgba(56, 189, 248, 0.15);
}

.settings-chart-empty {
  text-align: center;
  color: #94a3b8;
  font-size: 0.875rem;
  padding: 96px 24px;
}

/* ─── Notification settings ───────────────────────────────────────────────── */
.notification-block {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px 24px;
  margin: 0 auto 16px;
  max-width: 98%;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
}

.notification-toggle {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.9375rem;
  font-weight: 500;
  color: #0f172a;
  cursor: pointer;
}

.notification-toggle input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: #38bdf8;
  cursor: pointer;
  flex-shrink: 0;
}

.notification-field-label {
  display: block;
  font-size: 0.8125rem;
  font-weight: 500;
  color: #64748b;
  margin: 16px 0 8px;
  text-align: center;
}

.notification-field-input {
  display: block;
  width: 260px;
  margin: 0 auto;
  padding: 10px 12px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-size: 0.875rem;
  color: #0f172a;
  outline: none;
  box-sizing: border-box;
}

.notification-field-input:focus {
  border-color: #38bdf8;
  box-shadow: 0 0 0 3px rgba(56, 189, 248, 0.15);
}

.settings-save-btn {
  display: block;
  margin: 28px auto 0;
  padding: 12px 28px;
  border: none;
  border-radius: 8px;
  background: #38bdf8;
  color: #ffffff;
  font-size: 0.9375rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.settings-save-btn:hover:not(:disabled) {
  background: #0ea5e9;
}

.settings-save-btn:disabled {
  background: #94a3b8;
  cursor: not-allowed;
}

.settings-loading {
  padding: 48px;
  text-align: center;
  color: #64748b;
  font-size: 0.9375rem;
  width: 100%;
}

/* ─── Empty states ────────────────────────────────────────────────────────── */
.settings-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 320px;
  padding: 48px 24px;
  background: #ffffff;
  border: 1px dashed #cbd5e1;
  border-radius: 12px;
  color: #64748b;
  text-align: center;
}

.settings-empty-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  color: #94a3b8;
  font-size: 1.5rem;
}

.settings-empty-state span {
  font-size: 0.9375rem;
  font-weight: 500;
}

/* ─── Responsive ──────────────────────────────────────────────────────────── */
@media (max-width: 900px) {
  .settings-sidebar {
    width: 230px;
    min-width: 230px;
  }

  .settings-content {
    padding: 24px 16px 40px;
  }

  .dropdown-container {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Css/Settings.css"],"names":[],"mappings":"AAAA,gFAAgF;AAChF;EACE,aAAa;EACb,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,gFAAgF;AAChF;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB;;mBAEiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,kFAAkF;AAClF;;;;EAIE,WAAW;EACX,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,gFAAgF;AAChF;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,kEAAkE;EAClE,gDAAgD;EAChD,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;;EAKE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,eAAe;EACf;;wBAEsB;EACtB,WAAW;EACX,SAAS;EACT,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;;;;EAIE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,kFAAkF;AAClF;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;AAChB;;AAEA,kFAAkF;AAClF;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,UAAU;EACV,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,gFAAgF;AAChF;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;;AAEA;;;EAGE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,SAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA,gFAAgF;AAChF;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,gFAAgF;AAChF;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,kFAAkF;AAClF;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,gFAAgF;AAChF;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,WAAW;AACb;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,gFAAgF;AAChF;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* ─── Settings layout ─────────────────────────────────────────────────────── */\r\n.settings-container {\r\n  display: flex;\r\n  height: calc(100vh - 50px);\r\n  margin-top: 50px;\r\n  overflow: hidden;\r\n  background: #f1f5f9;\r\n}\r\n\r\n.settings-sidebar {\r\n  width: 280px;\r\n  min-width: 280px;\r\n  height: 100%;\r\n  flex-shrink: 0;\r\n  background: #ffffff;\r\n  border-right: 1px solid #e2e8f0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 0;\r\n  overflow: hidden;\r\n  box-shadow: 2px 0 12px rgba(15, 23, 42, 0.04);\r\n}\r\n\r\n.settings-sidebar-header {\r\n  padding: 24px 20px 18px;\r\n  border-bottom: 1px solid #f1f5f9;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.settings-sidebar-header h3 {\r\n  margin: 0 0 6px;\r\n  font-size: 1.25rem;\r\n  font-weight: 700;\r\n  color: #0f172a;\r\n  letter-spacing: -0.02em;\r\n}\r\n\r\n.settings-sidebar-header p {\r\n  margin: 0;\r\n  font-size: 0.8125rem;\r\n  color: #64748b;\r\n  line-height: 1.4;\r\n}\r\n\r\n.settings-nav {\r\n  padding: 12px 10px 20px;\r\n  overflow: hidden;\r\n  flex: 1;\r\n}\r\n\r\n.settings-content {\r\n  flex: 1;\r\n  min-width: 0;\r\n  height: 100%;\r\n  padding: 32px 24px 48px;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  background: #f1f5f9;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: flex-start;\r\n}\r\n\r\n/* ─── Sidebar navigation ──────────────────────────────────────────────────── */\r\n.sidebar-item {\r\n  padding: 11px 14px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  margin-bottom: 4px;\r\n  border-radius: 8px;\r\n  transition:\r\n    background-color 0.2s ease,\r\n    color 0.2s ease;\r\n  color: #475569;\r\n  font-size: 0.875rem;\r\n  font-weight: 500;\r\n  border: 1px solid transparent;\r\n}\r\n\r\n.sidebar-item:hover {\r\n  background-color: #f8fafc;\r\n  color: #0f172a;\r\n}\r\n\r\n.sidebar-item.active {\r\n  background: linear-gradient(135deg, #e0f2fe 0%, #f0f9ff 100%);\r\n  color: #0369a1;\r\n  border-color: #bae6fd;\r\n  font-weight: 600;\r\n}\r\n\r\n.sidebar-item.active svg {\r\n  color: #0284c7;\r\n}\r\n\r\n.sidebar-item svg {\r\n  flex-shrink: 0;\r\n  width: 20px;\r\n  height: 20px;\r\n  color: #94a3b8;\r\n  transition: color 0.2s ease;\r\n}\r\n\r\n.sidebar-item:hover svg {\r\n  color: #64748b;\r\n}\r\n\r\n.sidebar-item-label {\r\n  line-height: 1.3;\r\n}\r\n\r\n/* ─── Page shell (centered on content area) ─────────────────────────────────── */\r\n.settings-panel,\r\n.dispatcher-settings,\r\n.order-creation-settings,\r\n.notification-settings {\r\n  width: 100%;\r\n  max-width: 95%;\r\n  margin: 0 auto;\r\n}\r\n\r\n.settings-page-header {\r\n  margin-bottom: 28px;\r\n  /* text-align: center; */\r\n}\r\n\r\n.settingsH2,\r\n.settings-page-header h2 {\r\n  font-size: 1.75rem;\r\n  font-weight: 700;\r\n  color: #0f172a;\r\n  margin: 0 0 8px;\r\n  letter-spacing: -0.03em;\r\n  font-family: inherit;\r\n}\r\n\r\n.settings-page-subtitle {\r\n  margin: 0 auto;\r\n  font-size: 0.9375rem;\r\n  color: #64748b;\r\n  line-height: 1.5;\r\n  max-width: auto;\r\n}\r\n\r\n/* ─── Cards & sections ────────────────────────────────────────────────────── */\r\n.settings-card {\r\n  background: #ffffff;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 12px;\r\n  padding: 24px 28px;\r\n  margin-bottom: 20px;\r\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);\r\n}\r\n\r\n.settings-card:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.settings-card-title {\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  color: #0f172a;\r\n  margin: 0 0 4px;\r\n  text-align: center;\r\n}\r\n\r\n.settings-card-desc {\r\n  font-size: 0.8125rem;\r\n  color: #64748b;\r\n  margin: 0 0 20px;\r\n  line-height: 1.45;\r\n  text-align: center;\r\n}\r\n\r\n.detailsh2 {\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  color: #0f172a;\r\n  margin: 0 0 16px;\r\n  font-family: inherit;\r\n}\r\n\r\n.setting-option {\r\n  margin: 0;\r\n}\r\n\r\n.setting {\r\n  margin: 0;\r\n}\r\n\r\n.settings-info-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\r\n  gap: 16px;\r\n}\r\n\r\n.settings-info-item {\r\n  padding: 14px 16px;\r\n  background: #f8fafc;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 8px;\r\n}\r\n\r\n.settings-info-label {\r\n  display: block;\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n  color: #64748b;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.settings-info-value {\r\n  font-size: 0.9375rem;\r\n  font-weight: 500;\r\n  color: #0f172a;\r\n  word-break: break-word;\r\n}\r\n\r\n/* ─── Form controls ───────────────────────────────────────────────────────── */\r\n.dropdown-container {\r\n  display: grid;\r\n  /* grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)); */\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: 20px;\r\n  margin: 0 auto;\r\n  max-width: auto;\r\n}\r\n\r\n.settingg {\r\n  margin: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.settingg label,\r\n.dropdown-container label {\r\n  font-size: 0.875rem;\r\n  font-weight: 500;\r\n  color: #334155;\r\n  line-height: 1.4;\r\n}\r\n\r\n.dropdown-container select,\r\n.settingg select,\r\n.settingg input[type=\"time\"],\r\n.settingg input[type=\"number\"],\r\n.settings-input {\r\n  padding: 10px 12px;\r\n  border: 1px solid #cbd5e1;\r\n  border-radius: 8px;\r\n  background-color: #ffffff;\r\n  font-size: 0.875rem;\r\n  color: #0f172a;\r\n  outline: none;\r\n  cursor: pointer;\r\n  transition:\r\n    border-color 0.2s ease,\r\n    box-shadow 0.2s ease;\r\n  width: 100%;\r\n  margin: 0;\r\n  font-family: inherit;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.dropdown-container select:focus,\r\n.settingg select:focus,\r\n.settingg input:focus,\r\n.settings-input:focus {\r\n  border-color: #38bdf8;\r\n  box-shadow: 0 0 0 3px rgba(56, 189, 248, 0.15);\r\n}\r\n\r\n/* ─── Centered form wrapper inside cards ────────────────────────────────────── */\r\n.settings-form-wrap {\r\n  width: 100%;\r\n  max-width: 420px;\r\n  margin: 0 auto !important;\r\n}\r\n\r\n.settings-save-row {\r\n  margin-top: 28px !important;\r\n  padding-top: 4px;\r\n  width: 100%;\r\n  text-align: center;\r\n}\r\n\r\n.settings-card .MuiTypography-body2 {\r\n  text-align: center;\r\n  max-width: 420px;\r\n  margin: 12px auto 0;\r\n  font-size: 0.8125rem;\r\n  color: #64748b;\r\n}\r\n\r\n/* ─── Compact toggle switches (settings page only) ──────────────────────────── */\r\n.settings-toggle-switch {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 26px;\r\n  height: 14px;\r\n  flex-shrink: 0;\r\n  vertical-align: middle;\r\n}\r\n\r\n.settings-toggle-switch input {\r\n  opacity: 0;\r\n  width: 0;\r\n  height: 0;\r\n}\r\n\r\n.settings-toggle-slider {\r\n  position: absolute;\r\n  cursor: pointer;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: #cbd5e1;\r\n  transition: 0.2s ease;\r\n  border-radius: 14px;\r\n}\r\n\r\n.settings-toggle-slider:before {\r\n  position: absolute;\r\n  content: \"\";\r\n  height: 8px;\r\n  width: 8px;\r\n  left: 3px;\r\n  bottom: 3px;\r\n  background-color: white;\r\n  transition: 0.2s ease;\r\n  border-radius: 50%;\r\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.settings-toggle-switch input:checked + .settings-toggle-slider {\r\n  background-color: #38bdf8;\r\n}\r\n\r\n.settings-toggle-switch input:focus + .settings-toggle-slider {\r\n  box-shadow: 0 0 0 2px rgba(56, 189, 248, 0.25);\r\n}\r\n\r\n.settings-toggle-switch input:checked + .settings-toggle-slider:before {\r\n  transform: translateX(12px);\r\n}\r\n\r\n/* ─── Toggle rows ─────────────────────────────────────────────────────────── */\r\n.toggle-row > *:last-child {\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.toggle-roww > *:last-child {\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.whatsapp-toggle-row > *:last-child {\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.toggle-row .settings-toggle-switch,\r\n.toggle-row .MuiSwitch-root {\r\n  flex-shrink: 0;\r\n}\r\n\r\n.toggle-row,\r\n.toggle-roww,\r\n.whatsapp-toggle-row {\r\n  width: 100%;\r\n  max-width: 420px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  padding: 12px 0;\r\n  border-bottom: 1px solid #f1f5f9;\r\n}\r\n\r\n.toggle-row:last-child,\r\n.toggle-roww:last-child,\r\n.whatsapp-toggle-row:last-child {\r\n  border-bottom: none;\r\n  padding-bottom: 0;\r\n}\r\n\r\n.toggle-row:first-child,\r\n.toggle-roww:first-child,\r\n.whatsapp-toggle-row:first-child {\r\n  padding-top: 0;\r\n}\r\n\r\n.toggle-row label,\r\n.toggle-roww label,\r\n.whatsapp-toggle-row label {\r\n  flex: 1;\r\n  min-width: 0;\r\n  font-size: 0.875rem;\r\n  font-weight: 500;\r\n  color: #334155;\r\n  margin: 0;\r\n  line-height: 1.4;\r\n}\r\n\r\n.toggle-group {\r\n  padding-top: 4px;\r\n  max-width: 420px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.order-creation-settings .Pickupp {\r\n  padding: 0;\r\n  font-size: 0.9375rem;\r\n  color: #0f172a;\r\n  margin: 0;\r\n  font-weight: 600;\r\n}\r\n\r\n/* ─── Dispatcher settings ─────────────────────────────────────────────────── */\r\n.dispatcher-section {\r\n  background: #ffffff;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 12px;\r\n  padding: 24px 28px;\r\n  margin-bottom: 20px;\r\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);\r\n}\r\n\r\n.dispatcher-section h3 {\r\n  padding: 0;\r\n  font-size: 1.0625rem;\r\n  color: #0f172a;\r\n  margin: 0 0 16px;\r\n  font-weight: 600;\r\n  text-align: center;\r\n}\r\n\r\n/* ─── WhatsApp settings ───────────────────────────────────────────────────── */\r\n.whatsapp-section-title {\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  color: #0f172a;\r\n  margin: 0 0 12px;\r\n  text-align: center;\r\n}\r\n\r\n.whatsapp-messages {\r\n  background: #ffffff;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 12px;\r\n  padding: 8px 20px;\r\n  margin: 0 auto 24px;\r\n  max-width: 98%;\r\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);\r\n}\r\n\r\n.whatsapp-settings-note {\r\n  font-size: 0.8125rem;\r\n  color: #64748b;\r\n  margin: 8px auto 0;\r\n  max-width: 420px;\r\n  padding: 12px 16px;\r\n  background: #fffbeb;\r\n  border: 1px solid #fde68a;\r\n  border-radius: 8px;\r\n  text-align: center;\r\n}\r\n\r\n.requiredFields {\r\n  color: #ef4444;\r\n  margin-left: 4px;\r\n}\r\n\r\n/* ─── Chart / billing section ───────────────────────────────────────────────── */\r\n.settings-chart-wrap {\r\n  position: relative;\r\n  padding-top: 8px;\r\n}\r\n\r\n.settings-chart-card {\r\n  background: #ffffff;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 12px;\r\n  padding: 24px;\r\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);\r\n}\r\n\r\n.settings-year-select {\r\n  position: absolute;\r\n  top: 16px;\r\n  right: 16px;\r\n  z-index: 10;\r\n  border: 1px solid #cbd5e1;\r\n  border-radius: 8px;\r\n  padding: 8px 12px;\r\n  font-size: 0.875rem;\r\n  color: #334155;\r\n  background: #ffffff;\r\n  outline: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.settings-year-select:focus {\r\n  border-color: #38bdf8;\r\n  box-shadow: 0 0 0 3px rgba(56, 189, 248, 0.15);\r\n}\r\n\r\n.settings-chart-empty {\r\n  text-align: center;\r\n  color: #94a3b8;\r\n  font-size: 0.875rem;\r\n  padding: 96px 24px;\r\n}\r\n\r\n/* ─── Notification settings ───────────────────────────────────────────────── */\r\n.notification-block {\r\n  background: #ffffff;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 12px;\r\n  padding: 20px 24px;\r\n  margin: 0 auto 16px;\r\n  max-width: 98%;\r\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);\r\n}\r\n\r\n.notification-toggle {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  font-size: 0.9375rem;\r\n  font-weight: 500;\r\n  color: #0f172a;\r\n  cursor: pointer;\r\n}\r\n\r\n.notification-toggle input[type=\"checkbox\"] {\r\n  width: 16px;\r\n  height: 16px;\r\n  accent-color: #38bdf8;\r\n  cursor: pointer;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.notification-field-label {\r\n  display: block;\r\n  font-size: 0.8125rem;\r\n  font-weight: 500;\r\n  color: #64748b;\r\n  margin: 16px 0 8px;\r\n  text-align: center;\r\n}\r\n\r\n.notification-field-input {\r\n  display: block;\r\n  width: 260px;\r\n  margin: 0 auto;\r\n  padding: 10px 12px;\r\n  border: 1px solid #cbd5e1;\r\n  border-radius: 8px;\r\n  font-size: 0.875rem;\r\n  color: #0f172a;\r\n  outline: none;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.notification-field-input:focus {\r\n  border-color: #38bdf8;\r\n  box-shadow: 0 0 0 3px rgba(56, 189, 248, 0.15);\r\n}\r\n\r\n.settings-save-btn {\r\n  display: block;\r\n  margin: 28px auto 0;\r\n  padding: 12px 28px;\r\n  border: none;\r\n  border-radius: 8px;\r\n  background: #38bdf8;\r\n  color: #ffffff;\r\n  font-size: 0.9375rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.settings-save-btn:hover:not(:disabled) {\r\n  background: #0ea5e9;\r\n}\r\n\r\n.settings-save-btn:disabled {\r\n  background: #94a3b8;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.settings-loading {\r\n  padding: 48px;\r\n  text-align: center;\r\n  color: #64748b;\r\n  font-size: 0.9375rem;\r\n  width: 100%;\r\n}\r\n\r\n/* ─── Empty states ────────────────────────────────────────────────────────── */\r\n.settings-empty-state {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 320px;\r\n  padding: 48px 24px;\r\n  background: #ffffff;\r\n  border: 1px dashed #cbd5e1;\r\n  border-radius: 12px;\r\n  color: #64748b;\r\n  text-align: center;\r\n}\r\n\r\n.settings-empty-icon {\r\n  width: 56px;\r\n  height: 56px;\r\n  border-radius: 50%;\r\n  background: #f1f5f9;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-bottom: 16px;\r\n  color: #94a3b8;\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.settings-empty-state span {\r\n  font-size: 0.9375rem;\r\n  font-weight: 500;\r\n}\r\n\r\n/* ─── Responsive ──────────────────────────────────────────────────────────── */\r\n@media (max-width: 900px) {\r\n  .settings-sidebar {\r\n    width: 230px;\r\n    min-width: 230px;\r\n  }\r\n\r\n  .settings-content {\r\n    padding: 24px 16px 40px;\r\n  }\r\n\r\n  .dropdown-container {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
